export enum TicketStatus {
    ATENDIMENTO_IMPLANT = "Atendimento de Implantação",
    INDEFINIDA = "Indefinida",
    SUPORTE = "Suporte",
    DUVIDA = "Dúvida",
    RETORNO = "Aguardando Retorno",
    EM_ATENDIMENTO = "Em Atendimento",
    EM_MANUTENCAO = "Em Manutenção",
    ERRO_INTERNO = "Erro Interno",
    ERRO_SIMULADO = "Erro Simulado",
    PA_ANALISE = "Análise de PA",
    EM_ESPECIFICACAO = "Em Especificação",
    AGUARDANDO_RECURSO = "Aguardando Recurso",
    PREVER_HORAS = "Prever Horas",
    ANALISE_DE_PREVIA = "Análise de Prévia",
    REVISAO_ESPECIFICA = "Revisão de especificação",
    REVISAO_PREVIA = "Revisão de Prévia",
    PROPOSTA_ENCAMINHADA = "Proposta Encaminhada",
    PA_CLIENTE = "PA no Cliente",
    DESENV = "Desenvolvimento",
    CORRECAO_SUSPENSA = "Correção Suspensa",
    PENDENTE = "Pendente",
    TESTAR = "Testar",
    ETAPA_INSTALACAO = "Etapas para instalação",
    EM_HOMOLOGACAO = "Em Homologação",
    AGUARD_CORR_FICHAS = "PA aguardando correção de fichas",
    AGUARDA_OFICIALIZ = "Aguardando oficialização",
    RETORNO_HOMOLOGACAO = "Retorno da Homologação",
    HOMOLOGADO = "Homologado",
    LIBERADO = "Liberado",
    SOLUCIONADO = "Solucionado",
    ENCERRADO = "Encerrado",
    CANCELADO = "Cancelado",
    EXPIRADO = "Expirado",
    LOGS_LIBERADOS = "Logs Liberados",
    SEM_RETORNO = "Sem Retorno",
    RETORNO_PA = "Retorno PA",
    RETORNO_ANALISE = "Retorno em análise",
    RETORNO_MANUTENCAO = "Retorno Manutenção",
    AGUARDANDO_ENVIO = "PA Aguardando envio para cliente",
    PREVIA_APROVADA = "Prévia aprovada",
    ANALISE_ESTIMATIVA = "Análise de estimativa",
    AGUARD_ESPEC = "Aguardando especificação",
    AGUARD_APROV_ESPEC = "Aguardando aprovação de especificação",
    AGUARDANDO_SEFAZ = "Aguardando homologação SEFAZ",
    AGUARD_HOMOL_FICHA_S = "Aguard. Homologação – Fichas solucionadas",
    AGUARD_TESTE_VER_OFI = "Aguard. testes da versão oficial",
    AGUARDANDO_VALIDACAO = "Aguardando validação",
    RETORNO_LEVANTAMENTO = "Retorno de Levantamento",
    RETORNO_INFORMACAO = "Aguardando Informação",
    SOLUCIONAR_CONFLITO = "Solucionar conflito",
    TESTAR_CONFLITO = "Testar conflito",
    FICHA_REPETIDA = "Ficha Repetida",
}

export const OPEN_TICKET_STATUS_CODES: Array<keyof typeof TicketStatus> = [
    "AGUARD_CORR_FICHAS",
    "AGUARD_ESPEC",
    "AGUARDA_OFICIALIZ",
    "AGUARDANDO_RECURSO",
    "ANALISE_DE_PREVIA",
    "ATENDIMENTO_IMPLANT",
    "CORRECAO_SUSPENSA",
    "DESENV",
    "DUVIDA",
    "EM_ATENDIMENTO",
    "EM_ESPECIFICACAO",
    "EM_HOMOLOGACAO",
    "EM_MANUTENCAO",
    "ERRO_INTERNO",
    "ERRO_SIMULADO",
    "FICHA_REPETIDA",
    "HOMOLOGADO",
    "INDEFINIDA",
    "LIBERADO",
    "LOGS_LIBERADOS",
    "PA_ANALISE",
    "PA_CLIENTE",
    "PENDENTE",
    "PREVER_HORAS",
    "PREVIA_APROVADA",
    "PROPOSTA_ENCAMINHADA",
    "RETORNO",
    "RETORNO_ANALISE",
    "RETORNO_HOMOLOGACAO",
    "RETORNO_LEVANTAMENTO",
    "RETORNO_MANUTENCAO",
    "RETORNO_PA",
    "REVISAO_ESPECIFICA",
    "REVISAO_PREVIA",
    "SOLUCIONADO",
    "SUPORTE",
    "TESTAR",
];
